import styled from 'styled-components'

const Container = styled.div`
  display: flex;
  min-height: 100vh;
`

export default Container
